// src/pages/AboutPage.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="ab-root">
      <style dangerouslySetInnerHTML={{ __html: STYLES }} />

      {/* HERO */}
      <section className="ab-hero">
        <button className="ab-back" onClick={() => navigate(-1)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
          </svg>
          Back
        </button>
        <div className="ab-badge">About Us</div>
        <h1>Authentic Products, <span className="grad">Guaranteed</span></h1>
        <p className="ab-lede">
          JepTags is the marketplace where every product is verified authentic by the brand that made it.
          No counterfeits. No guesswork. Just trust.
        </p>
      </section>

      {/* STATS */}
      <section className="ab-stats-row">
        <div className="ab-stat">
          <div className="ab-stat-n">100%</div>
          <div className="ab-stat-l">Authentic products</div>
        </div>
        <div className="ab-stat">
          <div className="ab-stat-n">50+</div>
          <div className="ab-stat-l">Verified brands</div>
        </div>
        <div className="ab-stat">
          <div className="ab-stat-n">2</div>
          <div className="ab-stat-l">Global offices</div>
        </div>
      </section>

      {/* MISSION */}
      <section className="ab-section">
        <div className="ab-section-inner">
          <div className="ab-section-label">Our Mission</div>
          <h2>Every Product Tells Its <span className="grad">True Story</span></h2>
          <p>
            Counterfeits cost consumers $500B every year — bad products, lost money, broken trust.
            We built JepTags because shoppers deserve to know exactly what they're buying and who made it.
          </p>
          <p>
            Every product on our shop is tagged with NFC or QR authentication. Scan it, and you see
            the manufacturer, the factory, the journey. If a brand can't verify it, it's not here.
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="ab-section ab-section-alt">
        <div className="ab-section-inner">
          <div className="ab-section-label">How We Work</div>
          <h2>Three Simple <span className="grad">Principles</span></h2>

          <div className="ab-principles">
            <div className="ab-principle">
              <div className="ab-principle-num">01</div>
              <h3>Brands verify themselves</h3>
              <p>Every seller on JepTags is a registered business. We vet them, they list only their own products.</p>
            </div>
            <div className="ab-principle">
              <div className="ab-principle-num">02</div>
              <h3>Products carry proof</h3>
              <p>Each item has an NFC or QR tag linked to the brand. Scan before you buy, scan after you receive.</p>
            </div>
            <div className="ab-principle">
              <div className="ab-principle-num">03</div>
              <h3>Trust, then shop</h3>
              <p>Transparent pricing, verified shipping, honest reviews. The story of every product is public.</p>
            </div>
          </div>
        </div>
      </section>

      {/* COMPANY */}
      <section className="ab-section">
        <div className="ab-section-inner">
          <div className="ab-section-label">The Company</div>
          <h2>Built by <span className="grad">BestSky American, Inc.</span></h2>
          <p>
            Founded in California with operations in Vietnam, JepTags is operated by BestSky American, Inc.
            We serve both brand partners (who protect their products) and shoppers (who want to buy with confidence).
          </p>

          <div className="ab-office-grid">
            <div className="ab-office">
              <div className="ab-office-flag">🇺🇸</div>
              <div className="ab-office-name">Headquarters</div>
              <div className="ab-office-addr">930 Rincon Cir<br/>San Jose, CA 95131<br/>United States</div>
            </div>
            <div className="ab-office">
              <div className="ab-office-flag">🇻🇳</div>
              <div className="ab-office-name">Operations</div>
              <div className="ab-office-addr">Hanoi, Vietnam</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="ab-cta">
        <h2>Start Shopping <span className="grad">With Confidence</span></h2>
        <p>Browse authentic products from verified brands.</p>
        <div className="ab-cta-btns">
          <Link to="/products" className="ab-btn-primary">Shop Products →</Link>
          <Link to="/brands" className="ab-btn-secondary">View Brands</Link>
        </div>
      </section>
    </div>
  );
}

const STYLES = `
.ab-root *,.ab-root *::before,.ab-root *::after{margin:0;padding:0;box-sizing:border-box}
.ab-root{
  --cyan:#00E5CC;--cyan-bright:#00FFE0;--teal:#22D97F;
  --navy-deep:#030a14;--navy:#0a1628;--navy-mid:#0F2140;
  font-family:'Sora',sans-serif;background:var(--navy-deep);color:#e0f0f0;min-height:100vh;
}
.ab-root a{color:var(--cyan);text-decoration:none}
.grad{background:linear-gradient(135deg,var(--cyan-bright),var(--cyan),var(--teal));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}

/* HERO */
.ab-hero{max-width:900px;margin:0 auto;padding:60px 24px 48px;text-align:center;position:relative}
.ab-back{position:absolute;top:60px;left:24px;display:inline-flex;align-items:center;gap:6px;background:none;border:1px solid rgba(0,229,204,0.15);color:rgba(224,240,240,0.6);font-family:'Sora',sans-serif;font-size:13px;padding:8px 16px;border-radius:8px;cursor:pointer;transition:all .3s}
.ab-back:hover{border-color:var(--cyan);color:var(--cyan)}
.ab-back svg{width:14px;height:14px}
.ab-badge{display:inline-block;padding:8px 20px;border-radius:100px;background:rgba(0,229,204,0.08);border:1px solid rgba(0,229,204,0.15);font-size:12px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:var(--cyan);margin-bottom:24px}
.ab-hero h1{font-size:clamp(36px,6vw,60px);font-weight:800;line-height:1.1;letter-spacing:-2px;margin-bottom:20px}
.ab-lede{font-size:18px;line-height:1.7;color:rgba(224,240,240,0.55);max-width:640px;margin:0 auto}

/* STATS */
.ab-stats-row{max-width:900px;margin:0 auto 48px;padding:0 24px;display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.ab-stat{padding:28px 20px;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.06);border-radius:18px;text-align:center}
.ab-stat-n{font-size:40px;font-weight:800;letter-spacing:-1.5px;color:var(--cyan);margin-bottom:4px}
.ab-stat-l{font-size:12px;color:rgba(224,240,240,0.5);text-transform:uppercase;letter-spacing:1px}

/* SECTIONS */
.ab-section{padding:60px 24px}
.ab-section-alt{background:rgba(15,33,64,0.3)}
.ab-section-inner{max-width:900px;margin:0 auto}
.ab-section-label{display:inline-block;padding:6px 14px;border-radius:100px;background:rgba(0,229,204,0.06);border:1px solid rgba(0,229,204,0.12);font-size:11px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:var(--cyan);margin-bottom:16px}
.ab-section h2{font-size:clamp(28px,4vw,40px);font-weight:800;line-height:1.2;letter-spacing:-1px;margin-bottom:20px}
.ab-section p{font-size:16px;line-height:1.8;color:rgba(224,240,240,0.6);margin-bottom:16px;max-width:720px}
.ab-section p:last-child{margin-bottom:0}

/* PRINCIPLES */
.ab-principles{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:32px}
.ab-principle{padding:28px;background:rgba(3,10,20,0.5);border:1px solid rgba(0,229,204,0.08);border-radius:18px}
.ab-principle-num{font-size:13px;font-weight:800;letter-spacing:2px;color:var(--cyan);margin-bottom:16px}
.ab-principle h3{font-size:18px;font-weight:700;color:#e0f0f0;margin-bottom:10px}
.ab-principle p{font-size:14px;line-height:1.65;color:rgba(224,240,240,0.55);margin:0}

/* OFFICES */
.ab-office-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:20px;margin-top:32px}
.ab-office{padding:24px;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.06);border-radius:16px}
.ab-office-flag{font-size:28px;margin-bottom:10px}
.ab-office-name{font-size:11px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--cyan);margin-bottom:8px}
.ab-office-addr{font-size:14px;line-height:1.6;color:rgba(224,240,240,0.6)}

/* CTA */
.ab-cta{max-width:900px;margin:0 auto;padding:60px 24px 100px;text-align:center}
.ab-cta h2{font-size:clamp(28px,4vw,40px);font-weight:800;letter-spacing:-1px;margin-bottom:16px}
.ab-cta p{font-size:16px;color:rgba(224,240,240,0.55);margin-bottom:28px}
.ab-cta-btns{display:flex;gap:12px;justify-content:center;flex-wrap:wrap}
.ab-btn-primary{padding:14px 28px;border-radius:12px;background:linear-gradient(135deg,var(--cyan-bright),var(--teal));color:var(--navy-deep);font-weight:700;font-size:15px;transition:transform .25s}
.ab-btn-primary:hover{transform:translateY(-2px)}
.ab-btn-secondary{padding:14px 28px;border-radius:12px;border:1px solid rgba(0,229,204,0.25);background:transparent;color:var(--cyan);font-weight:600;font-size:15px;transition:all .25s}
.ab-btn-secondary:hover{border-color:var(--cyan);background:rgba(0,229,204,0.04)}

@media(max-width:700px){
  .ab-back{position:static;margin-bottom:20px}
  .ab-hero{padding:40px 20px 32px}
  .ab-stats-row{grid-template-columns:1fr;gap:10px}
  .ab-principles{grid-template-columns:1fr}
  .ab-office-grid{grid-template-columns:1fr}
}
`;
